import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserAdminState } from '@modules/administration/models/user-admin-state.enum';
import { UserCountByAdminState } from '@modules/administration/models/user-count-by-admin-state';
import { UserAdminStateBadgeComponent } from '../user-state-badge/user-admin-state-badge.component';

@Component({
  selector: 'pxc-user-state-count',
  imports: [UserAdminStateBadgeComponent],
  templateUrl: './user-state-count.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserStateCountComponent {
  @Input() userCountByAdminState: UserCountByAdminState;

  UserState = UserAdminState;
}
